import { MenuItem } from '../../../../ui-components/lib/sidenav/sidenav.model';

/**
 * Shorter Products and Workflows names for the side menu. The old sidenav keeps
 * the full labels; these keys apply only while the side menu flag is on.
 */
const SIDE_MENU_GROUP_ITEM_LABELS: Record<string, string> = {
  productsOwnerType: 'side_menu_products_owner_type_item_label',
  productsPermissions: 'side_menu_products_permissions_item_label',
  productsVariables: 'side_menu_products_variables_item_label',
  workflowsOwnerCategory: 'side_menu_workflows_owner_category_item_label',
  workflowsPermissions: 'side_menu_workflows_permissions_item_label',
  workflowsConfigurations: 'side_menu_workflows_configurations_item_label',
  workflowsVariables: 'side_menu_workflows_variables_item_label',
};

/**
 * KUIP-68 admin menu: today's items, one per section, except Plan & Usage and System Settings,
 * which move into a Workspace Settings group as Subscription and General. The old sidenav keeps them as they are.
 */
export function buildAdminSideMenuSections(
  items: MenuItem[],
  translate: (key: string) => string,
  sideMenuEnabled = false
): MenuItem[][] {
  const planUsage = items.find(item => item.id === 'planUsage');
  const systemSettings = items.find(item => item.id === 'systemSettings');
  const children: MenuItem[] = [
    ...(planUsage
      ? [
          {
            ...planUsage,
            id: 'subscription',
            label: translate('side_menu_subscription_item_label'),
          },
        ]
      : []),
    ...(systemSettings
      ? [
          {
            ...systemSettings,
            id: 'general',
            label: translate('side_menu_general_item_label'),
          },
        ]
      : []),
  ];
  const sections = items
    .filter(item => item !== planUsage && item !== systemSettings)
    .map(item => [
      item.children?.length
        ? {
            ...item,
            expanded: false,
            children: sideMenuEnabled
              ? item.children.map(child => {
                  const key = child.id
                    ? SIDE_MENU_GROUP_ITEM_LABELS[child.id]
                    : undefined;
                  return key ? { ...child, label: translate(key) } : child;
                })
              : item.children,
          }
        : item,
    ]);
  return children.length
    ? [
        ...sections,
        [
          {
            id: 'workspaceSettings',
            label: translate('profile_dropdown_menu_workspace_settings_label'),
            path: '',
            children,
            expanded: false,
          },
        ],
      ]
    : sections;
}
